export const BASE_ROUTE = {
  ONBOARDING: "/onboarding",
  HOME: "/home",
  MY_MEDS: "/my-meds",
  CONSULTATIONS: "/consultations",
  PROFILE: "/profile",
  DOCUMENT_CENTER: "/document-center",
  COACHING: "/coaching",
  PROGRESS_TRACKER: "/progress-tracker",
  BILLING: "/billing",
  SHOP: "/shop",
} as const;

export const ADMIN_ROUTES = {
  COACHING: {
    BASE: `/admin${BASE_ROUTE.COACHING}`,
    CREATE_SESSION: `/admin${BASE_ROUTE.COACHING}/create-sessions`,
    EDIT_SESSION: `/admin${BASE_ROUTE.COACHING}/edit-sessions/:sessionId`,
  },
} as const;

export const ROUTES = {
  BASE: "/",
  LOGIN: "/login",
  RESET_PASSWORD: "/reset-password",
  FORGOT_PASSWORD: "/forgot-password",
  HOME: BASE_ROUTE.HOME,
  CONSULTATIONS: {
    OVERVIEW: BASE_ROUTE.CONSULTATIONS,
    PURPOSE: `${BASE_ROUTE.CONSULTATIONS}/purpose`,
    FOLLOW_UP: `${BASE_ROUTE.CONSULTATIONS}/follow-up`,
    SCHEDULE: `${BASE_ROUTE.CONSULTATIONS}/schedule`,
  },
  COACHING: {
    OVERVIEW: BASE_ROUTE.COACHING,
    PAST_APPOINTMENTS: `${BASE_ROUTE.COACHING}/past-appointments`,
    JOURNEY_SUPPORT_SCHEDULE: `${BASE_ROUTE.COACHING}/journey-support/schedule`,
    DIETITIAN_SCHEDULE: `${BASE_ROUTE.COACHING}/dietitian/schedule`,
  },
  DOCUMENT_CENTER: {
    OVERVIEW: BASE_ROUTE.DOCUMENT_CENTER,
    LABS: `${BASE_ROUTE.DOCUMENT_CENTER}/labs`,
    PRESCRIPTIONS: `${BASE_ROUTE.DOCUMENT_CENTER}/previous-prescriptions`,
    MEDICAL_RECORDS: `${BASE_ROUTE.DOCUMENT_CENTER}/medical-records`,
    DOCTOR_NOTES: `${BASE_ROUTE.DOCUMENT_CENTER}/doctor-notes`,
    LEVELS_RX_RESOURCES: `${BASE_ROUTE.DOCUMENT_CENTER}/levels-rx-resources`,
  },
  BILLING: {
    OVERVIEW: BASE_ROUTE.BILLING,
    CHANGE_SUBSCRIPTION: `${BASE_ROUTE.BILLING}/change-subscription`,
    UPGRADE_SUBSCRIPTION: `${BASE_ROUTE.BILLING}/upgrade-subscription`,
  },
  SHOP: {
    OVERVIEW: BASE_ROUTE.SHOP,
    SUMMARY: `${BASE_ROUTE.SHOP}/summary`,
  },
  PROFILE: {
    OVERVIEW: `${BASE_ROUTE.PROFILE}`,
    EDIT: `${BASE_ROUTE.PROFILE}/edit`,
  },
  MY_MEDS: BASE_ROUTE.MY_MEDS,
  ONBOARDING: {
    WELCOME: `${BASE_ROUTE.ONBOARDING}/welcome`,
    MAIN_INFO: `${BASE_ROUTE.ONBOARDING}/main-info`,
    JOURNEY_BEGIN: `${BASE_ROUTE.ONBOARDING}/journey-begin`,
    PAYMENT_AND_ACCOUNT: `${BASE_ROUTE.ONBOARDING}/payment-and-account`,
    INTAKE_FORM: `${BASE_ROUTE.ONBOARDING}/intake-form`,
  },
} as const;

export const MODAL_ROUTES = {
  DOCUMENT_CENTER: {
    LABS: `${BASE_ROUTE.DOCUMENT_CENTER}/labs`,
    PRESCRIPTIONS: `${BASE_ROUTE.DOCUMENT_CENTER}/previous-prescriptions`,
    MEDICAL_RECORDS: `${BASE_ROUTE.DOCUMENT_CENTER}/medical-records`,
    DOCTOR_NOTES: `${BASE_ROUTE.DOCUMENT_CENTER}/doctor-notes`,
    REMOVE_DOCUMENT: `${BASE_ROUTE.DOCUMENT_CENTER}/remove-document`,
    EDIT_DOCUMENT: `${BASE_ROUTE.DOCUMENT_CENTER}/edit-document`,
    PREVIEW_DOCUMENT: `${BASE_ROUTE.DOCUMENT_CENTER}/preview-document`,
  },
  BILLING: {
    CHANGE_SUBSCRIPTION: `${BASE_ROUTE.BILLING}/change-subscription`,
  },
} as const;
